import { render } from "./ContentAlternate.vue?vue&type=template&id=b2c91040"
import script from "./ContentAlternate.vue?vue&type=script&lang=js"
export * from "./ContentAlternate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__